import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Button } from 'components/Elements/Buttons/Button';
import { RecaptchaChallenge } from 'components/Elements/Inputs/RecaptchaChallenge';

export interface EmailStatementDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (captchaToken: string) => void;
  loading?: boolean;
  physicianName?: string;
}

export const EmailStatementDialog: React.FC<EmailStatementDialogProps> = ({ open, onClose, onConfirm, loading = false, physicianName }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [captchaToken, setCaptchaToken] = React.useState('');

  const handleConfirm = () => {
    if (!captchaToken) {
      return;
    }
    onConfirm(captchaToken);
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="email-statement-dialog-title" maxWidth="sm" fullScreen={fullScreen}>
      <DialogTitle id="email-statement-dialog-title">Confirm email statement</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          To protect against automated requests, please complete the reCAPTCHA before sending your statement.
        </DialogContentText>
        {physicianName && (
          <Typography variant="body2" sx={{ mb: 2 }}>
            Statement recipient: {physicianName}
          </Typography>
        )}
        <RecaptchaChallenge open={open} onTokenChange={setCaptchaToken} />
      </DialogContent>
      <DialogActions>
        <Button size="medium" variant="outlined" color="warning" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button size="medium" variant="contained" color="primary" onClick={handleConfirm} disabled={loading || !captchaToken}>
          Send Email
        </Button>
      </DialogActions>
    </Dialog>
  );
};
